import qs from "qs";
import { api } from "../config";

const getEvents = async (
  page = 1,
  filters: Array<number> = [],
  pageSize = 5,
  intersect?: boolean
) => {
  const filterObj: any = {};

  if (filters && filters.length > 0) {
    if (intersect) {
      filterObj.$and = filters.map((f) => {
        return {
          FilterTags: {
            $contains: `|${f}|`,
          },
        };
      });
    } else {
      filterObj.Tags = {
        id: {
          $in: filters,
        },
      };
    }
  }

  const query = qs.stringify(
    {
      sort: ["Date:asc"],
      filters: filterObj,
      pagination: {
        page: page,
        pageSize: pageSize,
      },
      populate: {
        Media: "*",
      },
    },
    {
      encodeValuesOnly: true,
    }
  );
  const res: any = await fetch(`${api}/events?${query}`);
  res.data = await res.json();
  return res;
};

export { getEvents };
